import { useState } from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const BaseFilter = ({ items, defaultValue, onFilterChange, label = "فیلتر" }) => {
  const [selected, setSelected] = useState(defaultValue);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    onFilterChange(value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel sx={{ lineHeight: "40px", top: "-8px" }}>{label}</InputLabel>
      <Select
        value={selected}
        onChange={handleChange}
        label={label}
        sx={{
          height: 40,
        }}
      >
        {items.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BaseFilter;
